export const SFH_ALLOWED_STATES = [
  { code: 'TX', name: 'Texas' },
  { code: 'CA', name: 'California' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'OR', name: 'Oregon' },
  { code: 'CO', name: 'Colorado' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'WA', name: 'Washington' },
  { code: 'MO', name: 'Missouri' },
  { code: 'NV', name: 'Nevada' },
];

export const isStateAllowedForSfh = (stateRegion) =>
  SFH_ALLOWED_STATES.some(
    (state) => state.code === String(stateRegion || '').toUpperCase(),
  );
